import AddIcon from "@mui/icons-material/Add";
import { Box, Divider, TextField, Typography } from "@mui/material";
import useColors from "../../../../../api/hooks/useColors";

const LabelsDropdownHeader = ({
  inputValue,
  setInputValue,
  onCreateLabel,
  showCreateButton,
}) => {
  const colors = useColors();
  const INPUT_LIMIT = 20;
  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" alignItems="center" height="36px">
        <TextField
          placeholder="Add labels..."
          variant="standard"
          value={inputValue}
          onChange={(e) => {
            const value = e.target.value;
            const filteredValue = value.replace(/[^a-zA-Z0-9 \-_]/g, "");
            const truncatedValue = filteredValue.slice(0, INPUT_LIMIT);
            setInputValue(truncatedValue);
          }}
          onKeyDown={(e) => {
            e.stopPropagation();
            if (e.key === "Enter" && inputValue.trim()) {
              onCreateLabel();
            }
          }}
          InputProps={{
            disableUnderline: true,
            sx: {
              "& .MuiInputBase-input": {
                color: colors.text_secondary,
                fontSize: "12px",
                padding: 0,
                "&::placeholder": {
                  color: colors.text_secondary,
                  opacity: 1,
                },
              },
            },
          }}
        />
      </Box>
      <Divider sx={{ borderColor: colors.grey_20percent }} />
      {showCreateButton && (
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap={1}
          alignItems={"center"}
          sx={{ cursor: "pointer" }}
          margin={"8px 0px 0px 0px"}
          paddingLeft={"2px"}
        >
          <AddIcon
            sx={{
              width: "18px",
              color: colors.text_secondary,
            }}
          />
          <Typography
            variant="overline"
            color={colors.text_secondary}
            onClick={onCreateLabel}
          >
            Create new label: "{inputValue}"
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default LabelsDropdownHeader;
